export default __webpack_public_path__ + "static/media/stuart-marshall-2021-contributions.d7f0fd00.png";